<template>
  <div class="profile_wrap">
    <div class="side_profile">
      <div class="navigation">
        <ul>
          <li class="list active">
            <router-link exact :to="{ path: '/profile/user' }">
              <span class="icon">
                <i class="bx bx-user"></i>
              </span>
              <span class="title">Profile</span>
            </router-link>
          </li>
          <li class="">
            <a @click.prevent="signOut()">
              <span class="icon">
                <i class="bx bx-log-out"></i>
              </span>
              <span class="title">Logout</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="side_prodile_content">
      <router-view></router-view>
    </div>

    <!-- {{user}} -->
  </div>
</template>
<script>
import $ from "jquery";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "profileApp",
  data() {
    return {
      percent: 0,
      color: "#c24b50",
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      get_setting: "get_setting",
      get_mystring: "get_mystring",
    }),
  },
  methods: {
    ...mapActions({
      signOutAction: "auth/signOut",
    }),
    signOut() {
      this.signOutAction().then(() => {
        this.$router.replace({
          name: "Login",
        });
      });
    },
    reduce_side() {
      const list = document.querySelectorAll(".list");
      $(".list")
        .find(".router-link-active")
        .parents(".list")
        .addClass("router-link-active");
      function activeLink() {
        list.forEach((item) => {
          //router-link-active
          // console.log(item.querySelector('.router-link-active').parentElement())
          item.classList.remove("router-link-active");
          $(item)
            .find(".router-link-active")
            .parents(".list")
            .addClass("router-link-active");
        });
        this.classList.add("router-link-active");
      }
      list.forEach((item) => item.addEventListener("click", activeLink));
    },
  },
  mounted() {
    this.reduce_side();
  },
};
</script>
<style lang="scss">
.side_prodile_content {
  width: calc(100% - 300px);
  margin-left: auto;
  padding-left: 30px;
  padding-right: 30px;
}
table tbody tr {
  cursor: pointer;
}
@media screen and (max-width: 992px) {
  .b-table .table-wrapper.has-mobile-cards tr {
    -webkit-box-shadow: 0 2px 3px rgb(10 10 10 / 10%),
      0 0 0 1px rgb(10 10 10 / 10%);
    box-shadow: 0 2px 3px rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 10%);
    max-width: 100%;
    position: relative;
    display: block;
  }
  .b-table .table-wrapper.has-mobile-cards tr:not([class*="is-"]) {
    background: var(--active_color) !important;
  }
  .b-table
    .table-wrapper.has-mobile-cards
    tr:not(.detail):not(.is-empty):not(.table-footer)
    td {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: auto;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    text-align: right;
    border-bottom: 1px solid whitesmoke;
  }
  .b-table .table-wrapper.has-mobile-cards thead tr th {
    display: none;
  }
  .b-table
    .table-wrapper.has-mobile-cards
    tr:not(.detail):not(.is-empty):not(.table-footer)
    td:before {
    content: attr(data-label);
    font-weight: 600;
    padding-right: 0.5em;
    text-align: left;
  }
}
// .container{
//    max-width: 100% !important;
//    padding: 0 !important;
// }
</style>
<style lang="scss" scoped>
.profile_wrap {
  padding-top: 32px;
  min-height: 100vh;
  position: relative;
  color: #fff;
  .navigation {
    position: absolute;
    height: 500px;
    //  width: 70px;
    width: 300px;
    background: url("https://images.pexels.com/photos/6873135/pexels-photo-6873135.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500");

    background-size: cover;
    box-shadow: 10px 0 0 var(--active_color);
    overflow-x: hidden;
    transition: width 0.5s;
    left: 0px;
    top: 0px;
    height: calc(100% - 100px);
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: black;
      opacity: 0.8;
    }
    .uk-logo {
      display: block;
      position: relative;
      z-index: 1;
      text-align: center;
      img {
        width: auto;
        height: 100px;
        object-fit: contain;
        padding: 12px;
      }
    }
    //   &:hover{
    //     width:300px;
    //   }
    ul {
      position: absolute;
      top: 50px;
      left: 0;
      width: 100%;
      padding-left: 5px;
      padding-right: 5px;

      li {
        position: relative;
        list-style: none;
        width: 84%;
        border-radius: 10px;
        margin: 0 auto;
        height: 50px;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        &.router-link-active {
          background: var(--active_color);
          .title {
            color: black;
            font-weight: 400;
            a {
              color: black !important;
            }
          }
          i {
            color: #000 !important;
          }
        }

        a {
          position: relative;
          display: flex;
          text-decoration: none;
          width: 100%;
          align-items: center;
          color: #000;

          .icon {
            position: relative;
            display: block;
            min-width: 60px;
            margin-top: -2px;
            text-align: center;
            color: black;
            i {
              position: relative;
              font-size: 1.5em;
              z-index: 1;
              color: white;
            }
          }

          .title {
            position: relative;
            display: block;
            padding-left: 4px;
            height: 60px;
            font-weight: 300;
            line-height: 60px;
            white-space: nowrap;
            color: white;
            font-size: 16px;
             font-family: "Oswald", sans-serif;
            font-weight: 500;
            letter-spacing: 1px;
          }
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .navigation {
    width: 70px !important;
  }
  .side_prodile_content {
    width: calc(100% - 77px) !important;
    margin-left: auto !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
  }
  .profile_wrap .navigation ul li a .title {
    display: none;
  }
  .profile_wrap .navigation ul li a {
    justify-content: center;
  }
}
@media (max-width: 767px) {
  .side_prodile_content {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
</style>
